module.exports = __webpack_public_path__ + "static/media/inteligencia-artificial.2558c23d.png";